import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

type ContainerProps = {
  secondary?: boolean
  size?: number
}

const shouldForwardProp = (prop: string) =>
  !['size', 'secondary'].includes(prop)

const containerSecondaryCss = ({ secondary }: ContainerProps) =>
  secondary &&
  css`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    color: ${themeGet('colors.primary.dark')};

    &:hover {
      transform: scale(1.1, 1.1);
    }
  `

const containerSizeCss = ({ size }: ContainerProps) =>
  size &&
  css`
    > svg {
      width: ${size}px;
      height: ${size}px;
    }
  `

export const Container = styled.a.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  color: ${themeGet('colors.text.important')};
  background-color: ${themeGet('colors.text.inverse')};

  ${containerSecondaryCss}
  ${containerSizeCss}
`
